import React, { useState, ReactNode } from 'react';
import classNames from 'classnames';
import { ValidateState, bindStateToRadio, bindStateToCheckbox, bindStateToText } from '../utils/entry-utils';

type RadioProps<T> = {
	state: ValidateState<T>;
	value: T;
	disabled?: boolean;
	hide?: boolean;
	validate?: boolean;
	name: string;
	children: ReactNode;
	comparator?: (a: T, b: T) => boolean;
};

export const Radio = <T extends unknown>({ state, value, children, disabled, validate, name, comparator, hide }: RadioProps<T>) => {
	const [currentValue, setValue, validator] = state;
	const isSelected = comparator ? comparator(currentValue, value) : currentValue === value;
	const handleClick = () => {
		if (!disabled && !isSelected) {
			setValue(value);
		}
	};
	if(hide) return null
	return (
		<div
			className={classNames('radio-label', {
				selected: isSelected,
				disabled: disabled,
				invalid: validate && !validator()
			})}
			onClick={handleClick}
		>
			{/* inputはアクセシビリティのためにhiddenで残す */}
			<input
				type="radio"
				name={name}
				disabled={disabled}
				checked={isSelected}
				readOnly
				tabIndex={-1}
			/>
			<div className="radio-label-container">{children}</div>
		</div>
	);
};

export function RadioLabel({ state, value, children, disabled, validate }: any) {
	const [currentValue, , validator] = state;
	return <label className={classNames('radio-label', {
		selected: currentValue === value,
		disabled: disabled,
		invalid: validate && !validator()
	})}>
		<div className="radio-label-container">{children}</div>
	</label>;
}

export function RadioContainer({ label, children }: { label?: ReactNode; children: ReactNode; }) {
	return <div className="radio-container">
		<p className="label">{label}</p>
		<div>
			{children}
		</div>
	</div>;
}

export function Checkbox<T>({ state, children, validate, name }: { state: ValidateState<T>; children?: ReactNode; validate?: boolean; name: string; }) {
	const [, , validator] = state;
	return <label className={classNames('checkbox-label', {
		invalid: validate && !validator()
	})}>
		<input type="checkbox" {...bindStateToCheckbox(state)} name={name} />
		{children}
	</label>;
}

export function Text<T>({ state, label, replacer, placeholder = '', name, maxLength }: { state: ValidateState<T>; label: string; replacer?: (value: T | string) => T; placeholder?: string; name: string; maxLength?: number; }) {
	const [value, setValue, validator] = state;
	const [blur, setBluer] = useState(false);
	return <label className={classNames('text-label', {
		invalid: blur && !validator()
	})}>
		<div className="label">{label}</div>
		<input type="text" name={name} {...bindStateToText(state)} maxLength={maxLength} placeholder={placeholder} onBlur={() => {
			setBluer(true);
			if (typeof replacer === 'function') {
				const replaced = replacer(value);
				if (value !== replaced) {
					setValue(replaced);
				}
			}
		}} />
	</label>;
}
